import React from 'react';

import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';

import Chapter from './Chapter';

const useStyles = makeStyles(theme => ({
  root: {
    //backgroundColor: '#322e2e',
    backgroundColor: '#000',
    padding: theme.spacing(3)
  },
  title: {
    color: '#ccc',
    textTransform: 'uppercase',
    marginBottom: theme.spacing(3)
  }
}));

export default (props) => {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <div><h3 className={classes.title}>Chapter Points</h3></div>
      <Grid container direction="row" spacing={3}>
        { props.config.chapters.map( (chapter, index) => (
          <Grid item md={4} sm={6} xs={12} key={index}>
            <Chapter config={chapter} setCurrentTime={props.setCurrentTime} currentTime={props.currentTime}  />
          </Grid>
        ))}
      </Grid>
    </div>
  );
};